module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isSubStatusPendingActive && _vm.getIsUserSubstituted) ? _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'left',
        arrow: false,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window'
      }),
      expression: "{\n            placement: 'left',\n             arrow: false,\n           animateFill: false,\n              animation : 'shift-away',\n            zIndex: '999999992',\n             boundary: 'window'\n          }"
    }],
    staticClass: "flex set-status",
    attrs: {
      "content": _vm.$t('vue2.sub_scheduler.is_substituted')
    }
  }, [_c('div', {
    staticClass: "dot"
  })]) : _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeDropDown),
      expression: "closeDropDown"
    }],
    staticClass: "flex set-status pointer",
    class: 'do-' + _vm.dropdownPlacement,
    on: {
      "click": function($event) {
        _vm.showDropdown = true
      }
    }
  }, [_c('div', {
    staticClass: "dot",
    class: [_vm.statusDotClass, {
      'mini-dot--loading': _vm.isSubmitting
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow icon-arrow-down"
  }), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
    staticClass: "dropdown sub-status__dropdown",
    class: {
      'sub-status__dropdown--loading': _vm.isSubmitting
    }
  }, [(_vm.isSubmitting) ? _c('div', {
    staticClass: "do-spinner__container"
  }, [_c('div', {
    staticClass: "do-spinner do-spinner--large"
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "sub-status__dropdown__list"
  }, [(!_vm.getIsUserSubstituted) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setStatus(0)
      }
    }
  }, [_c('div', {
    staticClass: "dot dot-white"
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.not_handled')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isSubStatusPendingActive) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setStatus(2)
      }
    }
  }, [_c('div', {
    staticClass: "dot dot-yellow"
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.pending')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setStatus(1)
      }
    }
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.handled')) + "\n        ")]), _vm._v(" "), (_vm.othersOnLessonAbsence.length > 0) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setStatusForAll(1)
      }
    }
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.handled_for_absence')) + "\n        ")]) : _vm._e()])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e59bcd5c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/Scheduler/SchedulerItemPopoverStatus.vue
// module id = 2149
// module chunks = 1